import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'neoris-dialog-pause-alert',
  templateUrl: './dialog-pause-alert.component.html',
  styleUrl: './dialog-pause-alert.component.css'
})
export class DialogPauseAlertComponent {

  public hourValues: string[] = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
  public minuteValues: string[] = [
    '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
    '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
    '20', '21', '22', '23', '24', '25', '26', '27', '28', '29',
    '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
    '40', '41', '42', '43', '44', '45', '46', '47', '48', '49',
    '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'
  ];

  public selectedDate: Date = new Date(); // seleccionada por defecto hoy
  public minDate: Date = new Date();      // mínima fecha: hoy
  public selectedHour: any 
  public selectedMinute: any  


  private deviceAlertId: number = 0
  public text: string = ""
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogPauseAlertComponent>
  ) {
    this.text = data.text;
    this.deviceAlertId = data.deviceAlertId
    this.selectedHour = data.selectedHour
    this.selectedMinute = data.selectedMinute
  }


  pause() {

    const pausedTo = new Date(this.selectedDate);
    pausedTo.setHours(+this.selectedHour);
    pausedTo.setMinutes(+this.selectedMinute);
    pausedTo.setSeconds(0);
    pausedTo.setMilliseconds(0);

    this.dialogRef.close({
      Id: this.deviceAlertId,
      Paused: true,
      PausedTo: pausedTo
    })
  }

  cancel() {
    this.dialogRef.close({
      Id: this.deviceAlertId,
      Paused: false,
      PausedTo: this.selectedHour + ":" + this.selectedMinute
    })
  }
}
